import GenerationChartPanel from './GenerationChartPanel';
import './GenerationChartPanel.scss';

export default GenerationChartPanel;
